import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import LogoSwitcher from '../../hooks/HoverSwitcher.js';
import { AppContext } from '../../context/appContext.js';
import MenuIcon from '../../assets/icons/menu_icon.svg';
import LogoIcon from '../../assets/icons/logo4.png';
import LogoIcon2 from '../../assets/icons/logo6.png';

export default function Navbar() {
  const { isExpanded, isPopUp } = useContext(AppContext);
  const { pathname } = useLocation();
  const pageClass = pathname === '/' ? 'home' : pathname.slice(1).replace(/\//g, '-');
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);
  const btnRef = useRef(null);

  const toggleMenu = () => setMenuOpen(open => !open);
  const navigate = useNavigate();

  const goToUpload = () => {
    navigate('/upload');
  };

  useEffect(() => {
    const handleClickOutside = e => {
      if (
        menuOpen &&
        navRef.current &&
        !navRef.current.contains(e.target) &&
        btnRef.current &&
        !btnRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  return (
    <header className={`landing-header ${isPopUp ? 'popup' : ''} ${pageClass}`}>
      <div className={`navbar-top-gutter ${isPopUp ? 'popup' : ''} ${pageClass}`}></div>
      <div className='navbar'>
        <Link to='/'>
          <LogoSwitcher
            main={LogoIcon}
            alt={LogoIcon2}
            color="#ddd"
            hoverColor="#6e41c1"
            size='48px'
            className='logo-icon'
          />
        </Link>

        <button
          type='button'
          className='menu-toggle'
          onClick={toggleMenu}
          aria-label='Toggle menu'
          ref={btnRef}
        >
          <img src={MenuIcon} alt='Menu' />
        </button>

        <nav className={menuOpen ? 'nav-open' : ''} ref={navRef}>
          <ul className='nav-links'>
            <li><Link to='/'>Home</Link></li>
            <li><Link to='/about'>About</Link></li>
            <li><Link to='/contact'>Contact</Link></li>
            {menuOpen && (<li><Link to='/upload'>Upload Resume</Link></li>)}
          </ul>
        </nav>

        <div className='cta-btn-wrapper'>
          <Link to='/upload' className='navbar-cta-btn'>Upload Resume</Link>
        </div>
      </div>
    </header>
  );
}


